import * as React from 'react'

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 27"
    className="design-iconfont"
    {...props}
  >
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="98.993%" id="76oc4ldsjb">
        <stop stopColor="#94D87B" offset="0%" />
        <stop stopColor="#67B85B" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="i8e8s13nxa">
        <stop stopColor="#B1E89D" offset="0%" />
        <stop stopColor="#92CD89" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="15.078%"
        y1="14.721%"
        x2="91.089%"
        y2="87.999%"
        id="ay9ppqhuzc"
      >
        <stop stopColor="#ECF7E8" offset="0%" />
        <stop stopColor="#ECF7E8" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.5.821c2.85 0 5.43 1.155 7.297 3.023a10.287 10.287 0 0 1 3.023 7.297c0 2.468-1.54 5.495-3.44 8.161-2.494 3.499-5.655 6.52-6.88 6.52-1.225 0-4.386-3.021-6.88-6.52-1.9-2.666-3.44-5.693-3.44-8.161 0-2.85 1.155-5.43 3.023-7.297A10.287 10.287 0 0 1 11.5.82Z"
        stroke="url(#76oc4ldsjb)"
        fill="url(#i8e8s13nxa)"
      />
      <path
        d="M10.952 4.501a4.801 4.801 0 0 0-1.218-.97 5.581 5.581 0 0 0-1.827-.648 5.656 5.656 0 0 0-.435-.058 5.755 5.755 0 0 0-2.504.301c.314-.281.66-.611 1.006-.98A13.455 13.455 0 0 0 7.527.163C7.593.056 7.45-.03 7.278.01a7.065 7.065 0 0 0-1.399.478 5.03 5.03 0 0 0-1.267.824c-.076.07-.148.14-.218.214-.438.465-.696.98-.78 1.505-.272-.333-.658-.556-1.143-.64a2.417 2.417 0 0 0-.206-.027 3.495 3.495 0 0 0-1.057.08c-.335.072-.69.19-1.058.349-.13.055-.196.174-.114.208.28.115.894.338 1.733.483.294.051.578.085.837.108-.436.15-.843.424-1.18.83-.073.088-.141.18-.203.275-.292.446-.461.96-.511 1.497-.046.453-.003.912.116 1.351.04.144.232.213.34.124.36-.3 1.063-.924 1.738-1.77.388-.486.703-.964.938-1.357.239.196.462.407.671.632A6.147 6.147 0 0 1 6.18 9.01h-.037c-1.75 0-3.306.716-4.3 1.99h8.603c-.47-.643-1.061-1.048-1.743-1.387a5.681 5.681 0 0 0-.274-.13 6.124 6.124 0 0 0-1.419-3.69 7.531 7.531 0 0 0-1.346-1.275c.483.08 1.022.154 1.599.21 1.556.151 2.88.12 3.518.088.187-.01.285-.188.172-.315"
        transform="translate(6 5)"
        fill="url(#ay9ppqhuzc)"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgComponent
